export default __webpack_public_path__ + "static/media/GPA24070B_light_bulb.347daed7.png";